import React from "react";
import Layout from "../../components/Layout.tsx";
import Title from "../../components/Title.tsx";
import EditMandatoryDays from "../../components/config/EditMandatoryDays.tsx";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";

const MandatoryDaysPage = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  useAppSettings();
  return (
    <Layout>
      <Title title="Temporadas bloqueadas" baseTitle="Configuración" basePath="/configuracion" />
      <div className="container-fluid">
        <div className="card border-0 shadow-sm rounded-3">
          <div className="card-header bg-white border-bottom-0 pt-4 px-4">
            <h5 className="mb-1">Temporadas bloqueadas</h5>
            <p className="text-muted mb-0 fs-14px">
              Administra fechas bloqueadas por temporada para planeación operativa.
            </p>
          </div>
          <div className="card-body pt-3 px-4 pb-4">
            <EditMandatoryDays closeFn={() => {}} setLoading={setLoading} showAssignmentControls={false} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MandatoryDaysPage;
